import { QueryObserverResult } from "@tanstack/react-query";
import { UserType } from "types/UsersTypes";

const POLL_MAX_ATTEMPTS = 20;
const POLL_INTERVAL_MS = 1000;

const pollMeForPackage = async (
  refetchMe: () => Promise<QueryObserverResult<UserType, Error>>,
  expectedPackage: string
): Promise<void> => {
  for (let attempt = 0; attempt < POLL_MAX_ATTEMPTS; attempt++) {
    const { data } = await refetchMe();
    if (data?.package === expectedPackage) {
      return;
    }
    await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
  }
};

export default pollMeForPackage;
